import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-floor-plan.png'

const FloorPlanIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} size={props.size} />
}

export default FloorPlanIcon
